module.exports = __webpack_public_path__ + "static/img/comunidado_SITREA.3012d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comunidado_SITREA.png
// module id = 4kBa
// module chunks = 9